import React from "react"
import { injectIntl } from "react-intl"
import Checkbox from "../../../common/checkbox/checkbox.component"
import Icon from "../../../common/icon/icon.component"
import QuoteFormConfiguration from "../../../state/ecommerce-configuration/EcommerceQuoteFormConfiguration"
import { Intl } from "../../../state/helpers/IntlProps"
import { ecommerceItemLabelMessages } from "../messages/EcommerceItemMessages"

type OwnProps = {
    fieldName: string
    fieldLabel: string
    fieldType: string
    required: boolean
    subFields: QuoteFormConfiguration[]
    onChangeCallback: (name, field, changedToValue, parentField) => void
    dragHandle
    handleDelete: (fieldName: string) => void
    isSubField: boolean
    hide: boolean
    intl: Intl
    parentField: string

}


const EcommerceItems = (props: OwnProps) => {

    const handleNoClick = (e) => {
        e.preventDefault()
    }

    const handleDelete = () => {
        props.handleDelete(props.fieldName)
    }

    const mapSubFields = () => {
        return [props?.subFields?.map((field) => {
            let subField = field
            if (!(subField instanceof QuoteFormConfiguration)) {
                // @ts-ignore todo fix
                subField = new QuoteFormConfiguration(field)
            }
            if (subField instanceof QuoteFormConfiguration) {
                const subFieldAttributes = subField.getAttributes()
                return <EcommerceItems
                    key={subFieldAttributes.name}
                    fieldName={subFieldAttributes.name}
                    fieldLabel={subFieldAttributes.label}
                    fieldType={subFieldAttributes.type}
                    required={subFieldAttributes.required}
                    hide={subFieldAttributes.hide}
                    subFields={[]}
                    onChangeCallback={props.onChangeCallback}
                    dragHandle={props.dragHandle}
                    handleDelete={() => {
                        return
                    }}
                    isSubField={true}
                    intl={props.intl}
                    parentField={props.fieldName}
                />
            }
        })]

    }

    if (props) {
        if (props.isSubField) {
            return (
                <div>
                    <div>
                        <div className="quote-item row py-2 align-items-center">
                            <div className="col">
                                {ecommerceItemLabelMessages[props.fieldName] ?
                                    props.intl.formatMessage(ecommerceItemLabelMessages[props.fieldName]) : props.fieldName
                                }
                            </div>
                            <div className="col">
                                <label className="text-align-right">
                                    Label
                                </label>
                                <div className="input-group">
                                    <input
                                        name={props.fieldName}
                                        id={props.fieldName}
                                        type="text"
                                        className="form-control"
                                        value={props.fieldLabel}
                                        placeholder="Label"
                                        onChange={(e) => {
                                            props.onChangeCallback(props.fieldName, "label", e.target.value, props.parentField)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <label className="text-align-right mb-0">
                                    Required
                                </label>
                                <Checkbox id={"requiredId"} checked={props.required} onChange={isChecked => {
                                    props.onChangeCallback(props.fieldName, "required", isChecked, props.parentField)
                                }}/>
                            </div>
                            <div className="col">
                                <label className=" text-align-right">
                                    Hide
                                </label>
                                <Checkbox id={"requiredId"} checked={props.hide ? props.hide : false}
                                    onChange={isChecked => {
                                        props.onChangeCallback(props.fieldName, "hide", isChecked, props.parentField)
                                    }}/>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div>
                    <div>
                        <div className="quote-item row py-2 align-items-center">
                            <a href={"#"} className={"sort-handle"} onClick={handleNoClick} {...props.dragHandle}>
                                <Icon className={"lead"} value={"bars"}/>
                            </a>
                            <div className="col">
                                {ecommerceItemLabelMessages[props.fieldName] ?
                                    props.intl.formatMessage(ecommerceItemLabelMessages[props.fieldName]) : props.fieldName
                                }
                            </div>
                            <div className="col">
                                <label className=" text-align-right">
                                    Label
                                </label>
                                <div className="input-group">
                                    <input
                                        name={props.fieldName}
                                        id={props.fieldName}
                                        type="text"
                                        className="form-control"
                                        value={props.fieldLabel}
                                        placeholder="Label"
                                        onChange={(e) => {
                                            props.onChangeCallback(props.fieldName, "label", e.target.value, props.parentField)
                                        }}
                                    />
                                </div>
                            </div>
                            {!props.fieldName.includes("address") ?
                                <div className="col">
                                    <label className=" text-align-right mb-0">
                                        Required
                                    </label>
                                    <Checkbox id={"requiredId"} disabled={props.fieldName == "email" ? "disabled" : ""}
                                        checked={props.required} onChange={isChecked => {
                                            props.onChangeCallback(props.fieldName, "required", isChecked, props.parentField)
                                        }}/>
                                </div>
                                : <div className="col"></div>}

                            {props.fieldName !== "email" ?
                                <div>
                                    <button className={"btn btn btn-outline-danger"} onClick={handleDelete}>
                                        <Icon value={"trash"} className={"pr-1"}/>
                                    </button>
                                </div>
                                : <div>
                                    <button className={"btn btn btn-outline-danger"} disabled>
                                        <Icon value={"trash"} className={"pr-1"}/>
                                    </button>
                                </div>}

                        </div>
                        {props.subFields?.length > 0 ?
                            <div className="quote-item py-2">
                                <div className="">
                                    {mapSubFields()}
                                </div>
                            </div> : <></>}
                    </div>
                </div>

            )
        }

    }

    return <></>

}


export default injectIntl(EcommerceItems)


// WEBPACK FOOTER //
// ./src/settings/ecommerce/components/EcommerceItems.tsx